module.exports = __webpack_public_path__ + "static/media/clear-24px.dc9532a8.svg";